module.exports = __webpack_public_path__ + "img/alex_feedback_grey.723b77a2.svg";